/*
 * Yellow dots for the product rows ("Most wished for this week" and any other collection row that scrolls sideways).
 * They replace the "1/5" counter and the arrows: one dot per step, the dot you are on stretches into a pill,
 * and the dots follow the scroll as the row moves. Click a dot to go there. The theme's own slider keeps doing the
 * scrolling; this only draws the dots from the same numbers.
 */
(function () {
  'use strict';

  function setup(sc) {
    if (sc.__tpDots) return;
    var wrap = sc.querySelector('.slider-buttons');
    var slider = sc.querySelector('[id^="Slider-"]');
    var totalEl = wrap && wrap.querySelector('.slider-counter--total');
    if (!wrap || !slider || !totalEl) return;
    sc.__tpDots = true;

    var box = document.createElement('div');
    box.className = 'tp-dots';
    box.setAttribute('role', 'group');
    box.setAttribute('aria-label', 'Choose which products to show');
    wrap.appendChild(box);
    wrap.classList.add('has-dots');

    var dots = [];
    var offset = 0;
    var frame = 0;

    function stepWidth() {
      var items = Array.prototype.filter.call(slider.children, function (el) { return el.clientWidth > 0; });
      return items.length > 1 ? items[1].offsetLeft - items[0].offsetLeft : 0;
    }

    function paint() {
      frame = 0;
      offset = stepWidth();
      var pos = offset ? slider.scrollLeft / offset : 0;
      dots.forEach(function (dot, i) {
        var near = Math.max(0, 1 - Math.abs(pos - i));
        dot.style.setProperty('--tp-near', near.toFixed(3));
        dot.setAttribute('aria-current', near > 0.5 ? 'true' : 'false');
      });
    }

    function queue() { if (!frame) frame = window.requestAnimationFrame(paint); }

    function build() {
      var total = parseInt(totalEl.textContent, 10) || 0;
      if (dots.length === total) { queue(); return; }
      box.textContent = '';
      dots = [];
      for (var i = 0; i < total; i++) {
        (function (index) {
          var dot = document.createElement('button');
          dot.type = 'button';
          dot.className = 'tp-dot';
          dot.setAttribute('aria-label', 'Go to products ' + (index + 1) + ' of ' + total);
          dot.addEventListener('click', function () {
            slider.scrollTo({ left: index * (offset || stepWidth()), behavior: window.matchMedia('(prefers-reduced-motion: reduce)').matches ? 'auto' : 'smooth' });
          });
          box.appendChild(dot);
          dots.push(dot);
        })(i);
      }
      queue();
    }

    slider.addEventListener('scroll', queue, { passive: true });
    window.addEventListener('resize', queue);
    new MutationObserver(build).observe(totalEl, { childList: true, characterData: true, subtree: true });
    build();
    window.setTimeout(build, 600);
  }

  function init(scope) {
    (scope || document).querySelectorAll('.collection slider-component').forEach(setup);
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', function () { init(); });
  else init();
  document.addEventListener('shopify:section:load', function (e) { init(e.target); });
})();
